import { Injectable } from "@angular/core";
import { PORTAL_CONFIG, VEHICLE_MODELS } from "../config/config.constants";
import { ApiService } from "./api.service";
import { UtilsService } from "./utils.service";
import { BehaviorSubject, catchError, map, Observable, of, tap } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    private refreshTrigger$ = new BehaviorSubject<void>(undefined); // emette ogni volta che vuoi notificare

    constructor(private apiService: ApiService,
        private utilsService: UtilsService) { }


    triggerRefresh() {
        this.refreshTrigger$.next(); // forza l'emissione
    }

    onRefresh() {
        return this.refreshTrigger$.asObservable(); // i componenti si sottoscrivono a questo
    }


    getVehicleModels(uid): Observable<any[]> {
        console.log('>>> SERVICE: getVehicleModels() chiamato.');
        let params = {
            uidCustomer: uid
        };
        console.log('>>> SERVICE: Parametri costruiti:', params);

        return this.apiService.getWithParams(VEHICLE_MODELS, params).pipe(
            tap(apiResponse => console.log('>>> SERVICE PIPE: apiService.getWithParams ha emesso (risposta API)', apiResponse)),
            map((vehicleModels: any) => {
                console.log('>>> SERVICE PIPE: Entrando in map operator con', vehicleModels);
                if (!Array.isArray(vehicleModels)) {
                    console.error('>>> SERVICE PIPE: Errore MAP: I dati API non sono un array inaspettatamente.', vehicleModels);
                    return [];
                }
                const transformed = vehicleModels.map((item: any) => ({
                    label: item.modelName,
                    value: item.uid
                }));
                console.log('>>> SERVICE PIPE: Map trasformato in', transformed);
                return transformed;
            }),
            catchError(error => {
                console.error('>>> SERVICE PIPE: CatchError: Errore nella pipe del servizio:', error);
                return of([]);
            })
        );
    }

}